<script setup lang="ts">
import SVG from "@/stories/displays/SVG/SVG.vue";
import type { SVGName } from "@/SVGs";

interface Props {
  text?: string;
  iconSVG?: SVGName;
  iconSize?: string;
}

withDefaults(defineProps<Props>(), {
  iconSize: "1.25rem",
});

defineEmits<{
  click: [];
}>();
</script>

<template>
  <button
    type="button"
    :class="[
      'px-2 py-[1rem] flex gap-3 items-center text-left rounded-lg hover:bg-neutral50',
      'focus-visible-strong',
    ]"
    @click="$emit('click')"
  >
    <SVG
      v-if="iconSVG"
      :icon="iconSVG"
      :height="iconSize"
      :width="iconSize"
    ></SVG>

    <div v-if="text" class="b300 flex-grow">{{ text }}</div>
  </button>
</template>
